<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Guides</h4>
          <p class="category">Assign the Guides for this Departure</p>
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click.prevent="assignGuide"
          >
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top"
              >Assign a Guide<br />to this Departure</md-tooltip
            >
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <template v-if="guides.length">
        <div
          class="md-layout tour-guide-item"
          v-for="guide in guides"
          :key="guide.id"
        >
          <div class="md-layout-item md-size-70">
            <h6>{{ guide.last_name }}, {{ guide.first_name }}</h6>
          </div>
          <div class="md-layout-item md-size-30 text-right">
            <md-button
              class="md-just-icon md-simple md-danger"
              @click.prevent="removeGuide(guide)"
            >
              <md-icon>remove_circle</md-icon>
              <md-tooltip md-direction="top">Remove this Guide</md-tooltip>
            </md-button>
          </div>
        </div>
      </template>
      <md-empty-state
        v-else
        md-label="Guides..."
        md-description="No Guides have been assigned to this Departure."
      >
        <md-button class="md-primary md-raised" @click="assignGuide"
          >Assign a Guide</md-button
        >
      </md-empty-state>
    </md-card-content>

    <md-dialog :md-active.sync="showDialog" class="single-choice-dialog">
      <md-dialog-title>Assign a Guide</md-dialog-title>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addGuide)" class="mt-4">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label for="title">Select a Guide</label>
                <md-select v-model="selectedGuide" name="guide" id="guide">
                  <md-option
                    v-for="availableGuide in availableGuides"
                    :value="availableGuide.id"
                    :key="availableGuide.id"
                    >{{ availableGuide.last_name }},
                    {{ availableGuide.first_name }}
                    <span v-if="availableGuide.country"
                      >[{{ availableGuide.country }}]</span
                    >
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense"
              >Assign</md-button
            >
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </md-card>
</template>
<script>
import departureApi from "@/services/api/departure";
import guideApi from "@/services/api/guide";

import _filter from "lodash/filter";

export default {
  props: ["departure"],

  data() {
    return {
      guides: [],
      showDialog: false,
      availableGuides: [],
      selectedGuide: null
    };
  },

  methods: {
    getGuides() {
      departureApi
        .getGuides(this.departure)
        .then(response => {
          this.guides = response.data;
        })
        .catch(err => {});
    },

    getAvailableGuides() {
      guideApi
        .getAll()
        .then(response => {
          this.availableGuides = response.data;
        })
        .catch();
    },

    removeGuide(guide) {
      departureApi
        .removeGuide(this.departure, guide)
        .then(response => {
          this.guides = _filter(this.guides, function(e) {
            return e.id !== guide.id;
          });

          this.$notify({
            timeout: 2500,
            message: "The Guide has been removed.",
            icon: "cancel",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        })
        .catch(err => {});
    },

    assignGuide() {
      this.showDialog = true;
    },

    cancel() {
      this.showDialog = false;
      this.selectedGuide = null;
    },

    addGuide() {
      departureApi
        .assignGuide(this.departure, { guide_id: this.selectedGuide })
        .then(response => {
          this.guides.push(response.data);
          this.cancel();
        })
        .catch();
    }
  },

  mounted() {
    this.getGuides();
    this.getAvailableGuides();
  }
};
</script>
